export const LOGIN = "LOGIN";
export const RECOVER = "RECOVER";
export const LOGOUT = "LOGOUT";
export const REGISTER = "REGISTER";
export const CLEAR = "CLEAR";

export const FETCH_GAMES = "FETCH_GAMES";

// CART
export const ADD_GAME_TO_CART = "ADD_GAME_TO_CART";
export const REMOVE_GAME_FROM_CART = "REMOVE_GAME_FROM_CART";
// MAIL
export const MAIL_LOADING = "MAIL_LOADING";
export const MAIL_LOADING_END = "MAIL_LOADING_END";
export const MAIL_SENT = "MAIL_SENT";
export const MAIL_SENT_FAIL = "MAIL_SENT_FAIL";
export const QUERY_SENT = "QUERY_SENT";
export const QUERY_SENT_FAIL = "QUERY_SENT_FAIL";
export const MAIL_SENT_RESET = "MAIL_SENT_RESET";

// USER
export const ADD_GAME_TO_USER = "ADD_GAME_TO_USER";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_PROFILE_IMG = "UPDATE_USER_PROFILE_IMG";

//FEEDBACK
export const GET_FEEDBACKS = "GET_FEEDBACKS";
export const FEEDBACKS_LOADING = "FEEDBACKS_LOADING";
export const FEEDBACKS_LOADING_END = "FEEDBACKS_LOADING_END";
export const CREATE_FEEDBACK = "CREATE_FEEDBACK";
export const CREATE_FEEDBACK_FAIL = "CREATE_FEEDBACK_FAIL";
export const EDIT_FEEDBACK = "EDIT_FEEDBACK";
export const EDIT_FEEDBACK_FAIL = "EDIT_FEEDBACK_FAIL";
export const DELETE_FEEDBACK = "DELETE_FEEDBACK";
export const DELETE_FEEDBACK_FAIL = "DELETE_FEEDBACK_FAIL";

//GALLERY
export const GET_GALLERY = "GET_GALLERY";
export const GALLERY_LOADING = "GALLERY_LOADING";
export const GALLERY_LOADING_END = "GALLERY_LOADING_END";
export const CREATE_GALLERY = "CREATE_GALLERY";
export const CREATE_GALLERY_FAIL = "CREATE_GALLERY_FAIL";
export const EDIT_GALLERY = "EDIT_GALLERY";
export const EDIT_GALLERY_FAIL = "EDIT_GALLERY_FAIL";
export const DELETE_GALLERY = "DELETE_GALLERY";
export const DELETE_GALLERY_FAIL = "DELETE_GALLERY_FAIL";

// - FAV
export const ADD_GAME_TO_USER_FAV = "ADD_GAME_TO_USER_FAV";
export const REMOVE_GAME_FROM_USER_FAV = "REMOVE_GAME_FROM_USER_FAV";

//FAQ
export const GET_FAQS = "GET_FAQS";

//CONTENT
export const GET_CONTENT = "GET_CONTENT";
